import styled from "styled-components";
import {
    Color,
    Font,
    breakpoints,
    ColorDark,
  } from "@/shared/Constants";


export const ContainerBtnNewCollection = styled.div`
    display: flex;
    gap: 0.5rem;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 1rem;
    cursor: pointer;
    border-radius: 4px;
    color: ${Color.grey};
    ${Font.sansRegular};
   
    &:hover {
        background-color: ${Color.lightGrey};
        color: ${Color.linkColor};
    }
    .titleCard{
        ${Font.sansRegular};
        letter-spacing: 0px;
        color: ${Color.grey};
        text-transform: uppercase;
        font-size: 12px;
        line-height: 26px;
        &.m-right-auto {
            margin-right: auto !important;
        }
    }
`;